// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layouts


// Public/Home Components
import AutoCarousel from "./components/AutoCarousel ";
import TrustedPartners from './pages/TrustedPartners/TrustedPartners';
import SmartSolutions from './pages/SmartSolutions/SmartSolutions';
import TransactionStats from './pages/TransactionStats';
import UnlockRevenue from './pages/UnlockRevenue';
import SecurePayments from './pages/SecurePayments';
import Milestones from './pages/Milestones';
import AwardsSection from './pages/AwardSection';
import ComplianceCenter from './pages/ComplianceCenter';
import Downloadpage from './pages/Downloadpage';
import BoardMembers from './pages/BoardMembers';
import TAPAYSection from './pages/TAPAY';
import TestingService from './pages/TestingService';
import CyberSecuritySection from './pages/CyberSecuritySection';
import SeniorManagement from './pages/SeniorManagement';
import TaPayxPage from './pages/TaPayxPage';
import TAApiBankingPlatform from './pages/TAApiBankingPlatform';
import CitizenWallet from './pages/CitizenWallet';
import CareerSection from './pages/CareerSection';
import ContactSection from './pages/ContactSection';
import AboutPage from './pages/Aboutpage';
import BBPSService from './pages/BBPSService';
import UpiPayments from './pages/UpiPayments';
import SettlementSection from './pages/SettlementSection';
import JobApplicationForm from './pages/JobApplicationPage';


// Compliance Pages
import TAGTermsandConditions from "./pages/compliancepages/TAGTermsandConditions";
import CustomerGrievancePolicy from "./pages/compliancepages/CustomerGrievancePolicy";
import CustomerProtectionPolicy from './pages/compliancepages/CustomerProtectionPolicy';
import CustomerSecurityAwareness from './pages/compliancepages/CustomerSecurityAwareness';
import DataPrivacyPolicy from './pages/compliancepages/DataPrivacyPolicy';
import DisputeRedressalMechanism from './pages/compliancepages/DisputeRedressalMechanism';
import PPIRules from './pages/compliancepages/PPIRules';
import RolesResponsibilities from './pages/compliancepages/RolesResponsibilities';
import TAWalletTermsConditions from './pages/compliancepages/TAWalletTerms&Conditions';
import CSRProgramTripartiteAgreement from './pages/compliancepages/CSRProgramTripartiteAgreement';
import TermsConditionsKannada from './pages/compliancepages/TermsConditions–Kannada';
import TermsConditionHindi from './pages/compliancepages/TermsConditionsHindi';
import FraudAwareness from './pages/compliancepages/FraudAwareness';
import AadhaarHeroSection from "./pages/AadhaarHeroSection ";
// Dashboard Pages
import Dashboard from './components/Dashboard';

import NewJobForm from './pages/NewJobForm';
import DashboardLayout from './components/DashboardLayout';
import PublicLayout from './components/PublicLayout';
import LoginPage from './components/LoginPage';
import DownloadPage from "./pages/Downloadpage"
import QrDownload from './pages/QrDownload';
import QrGenerator from './pages/QrGenerator';
// import SingleQr from './pages/SingleQr'; // removed: broken test page
import AppLanding from './pages/AppLanding';
import OnboardingStack from './pages/OnboardingStack';
import PrivacyPolicy from './pages/compliancepages/PAPGprivacypolicy';
import PapgTermsOfService from './pages/compliancepages/PapgTermsofService';
// import QrCodeComponent from './pages/QrCodeComponent'; // removed: broken test page
import NewsTicker from './components/NewsTicker';
import PhishingAwareness from './infra/PhishingAwareness';
import PhishingReport from './infra/PhishingReport';

const Home = () => (
  <>
  {/* <NewsTicker /> */}
    <AutoCarousel />
    <TrustedPartners />
    <SmartSolutions />
    <TransactionStats />
    <UnlockRevenue />
    {/* <SecurePayments /> */}
    <Milestones />
    <AwardsSection />
        {/* <DownloadPage/> */}
  </>
);

const App = () => {
  return (
    <Routes>
      {/* Public Routes with Navbar & Footer */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/compliance-center" element={<ComplianceCenter />} />
        <Route path="/download" element={<Downloadpage />} />
        <Route path="/boardmembers" element={<BoardMembers />} />
        <Route path="/tapay" element={<TAPAYSection />} />
        <Route path="/testing-certification" element={<TestingService />} />
        <Route path="/security-awareness" element={<CyberSecuritySection />} />
        <Route path="/senior-management" element={<SeniorManagement />} />
        <Route path="/tapayx" element={<TaPayxPage />} />
        <Route path="/ta-api-banking-platform" element={<TAApiBankingPlatform />} />
        <Route path="/citizen-wallet" element={<CitizenWallet />} />
        <Route path="/career" element={<CareerSection />} />
        <Route path="/contactus" element={<ContactSection />} />
        <Route path="/aboutus" element={<AboutPage />} />
        <Route path="/bbps-services" element={<BBPSService />} />
        <Route path="/upipayments" element={<UpiPayments />} />
        <Route path="/reconciliation-settlement" element={<SettlementSection />} />
        <Route path="/job-application" element={<JobApplicationForm />} />
        <Route path="/aadhaar-auth-solutions" element={<AadhaarHeroSection />} />
           <Route path="/onboarding-stack" element={<OnboardingStack />} />

        {/* Compliance pages */}
        <Route path="/compliance-center/tag-wallet-terms-conditions" element={<TAGTermsandConditions />} />
        <Route path="/compliance-center/customer-grievance-policy" element={<CustomerGrievancePolicy />} />
        <Route path="/compliance-center/customer-protection-policy" element={<CustomerProtectionPolicy />} />
        <Route path="/compliance-center/customer-security-awareness-information" element={<CustomerSecurityAwareness />} />
        <Route path="/compliance-center/data-privacy-policy" element={<DataPrivacyPolicy />} />
        <Route path="/compliance-center/dispute-redressal-mechanism" element={<DisputeRedressalMechanism />} />
        <Route path="/compliance-center/ppi-rules" element={<PPIRules />} />
        <Route path="/compliance-center/roles-responsibilities-of-npci-psb-tpap" element={<RolesResponsibilities />} />
        <Route path="/compliance-center/ta-wallet-terms-conditions" element={<TAWalletTermsConditions />} />
        <Route path="/compliance-center/terms-of-reference-of-csr-program-tripartite-agreement" element={<CSRProgramTripartiteAgreement />} />
        <Route path="/compliance-center/terms-conditions-kannada" element={<TermsConditionsKannada />} />
        <Route path="/compliance-center/terms-conditions-hindi" element={<TermsConditionHindi />} />
        <Route path="/compliance-center/fraud-awareness" element={<FraudAwareness />} />
         <Route path="/compliance-center/papgprivacy-policy" element={<PrivacyPolicy />} />
            <Route path="/compliance-center/papg-termsof-service" element={<PapgTermsOfService />} />
        <Route path="/downloadqr" element={<QrDownload />} />
            <Route path="/generaterq" element={<QrGenerator/>} />
                  {/* <Route path="/singleqr" element={<SingleQr/>} /> */}
                  <Route path="/app" element={<AppLanding />} />
                   {/* <Route path="/qr" element={<QrCodeComponent />} /> */}
                  
      </Route>

      {/* Dashboard/Admin Routes without Navbar & Footer */}
       <Route path="login" element={<LoginPage/>} />
        <Route path="/taadmin" element={<DashboardLayout />}>
   
  <Route index element={<Dashboard />} />
    
  <Route path="new-job-form" element={<NewJobForm />} />

</Route>
<Route
 path="/phishing-awareness"
 element={<PhishingAwareness />}
/>
<Route
 path="/phishing-report"
 element={<PhishingReport />}
/>
    </Routes>
    
  );
};

export default App;



// // src/App.js
// import React from 'react';
// import { Routes, Route } from 'react-router-dom';

// // Layouts


// // Public/Home Components
// import AutoCarousel from "./components/AutoCarousel ";
// import TrustedPartners from './pages/TrustedPartners/TrustedPartners';
// import SmartSolutions from './pages/SmartSolutions/SmartSolutions';
// import TransactionStats from './pages/TransactionStats';
// import UnlockRevenue from './pages/UnlockRevenue';
// import SecurePayments from './pages/SecurePayments';
// import Milestones from './pages/Milestones';
// import AwardsSection from './pages/AwardSection';
// import ComplianceCenter from './pages/ComplianceCenter';
// import Downloadpage from './pages/Downloadpage';
// import BoardMembers from './pages/BoardMembers';
// import TAPAYSection from './pages/TAPAY';
// import TestingService from './pages/TestingService';
// import CyberSecuritySection from './pages/CyberSecuritySection';
// import SeniorManagement from './pages/SeniorManagement';
// import TaPayxPage from './pages/TaPayxPage';
// import TAApiBankingPlatform from './pages/TAApiBankingPlatform';
// import CitizenWallet from './pages/CitizenWallet';
// import CareerSection from './pages/CareerSection';
// import ContactSection from './pages/ContactSection';
// import AboutPage from './pages/Aboutpage';
// import BBPSService from './pages/BBPSService';
// import UpiPayments from './pages/UpiPayments';
// import SettlementSection from './pages/SettlementSection';
// import JobApplicationForm from './pages/JobApplicationPage';


// // Compliance Pages
// import TAGTermsandConditions from "./pages/compliancepages/TAGTermsandConditions";
// import CustomerGrievancePolicy from "./pages/compliancepages/CustomerGrievancePolicy";
// import CustomerProtectionPolicy from './pages/compliancepages/CustomerProtectionPolicy';
// import CustomerSecurityAwareness from './pages/compliancepages/CustomerSecurityAwareness';
// import DataPrivacyPolicy from './pages/compliancepages/DataPrivacyPolicy';
// import DisputeRedressalMechanism from './pages/compliancepages/DisputeRedressalMechanism';
// import PPIRules from './pages/compliancepages/PPIRules';
// import RolesResponsibilities from './pages/compliancepages/RolesResponsibilities';
// import TAWalletTermsConditions from './pages/compliancepages/TAWalletTerms&Conditions';
// import CSRProgramTripartiteAgreement from './pages/compliancepages/CSRProgramTripartiteAgreement';
// import TermsConditionsKannada from './pages/compliancepages/TermsConditions–Kannada';
// import TermsConditionHindi from './pages/compliancepages/TermsConditionsHindi';
// import FraudAwareness from './pages/compliancepages/FraudAwareness';
// import AadhaarHeroSection from "./pages/AadhaarHeroSection ";
// // Dashboard Pages
// import Dashboard from './components/Dashboard';

// import NewJobForm from './pages/NewJobForm';
// import DashboardLayout from './components/DashboardLayout';
// import PublicLayout from './components/PublicLayout';
// import LoginPage from './components/LoginPage';
// import DownloadPage from "./pages/Downloadpage"
// import QrDownload from './pages/QrDownload';
// import QrGenerator from './pages/QrGenerator';
// import SingleQr from './pages/SingleQr';
// import AppLanding from './pages/AppLanding';
// import OnboardingStack from './pages/OnboardingStack';
// import PrivacyPolicy from './pages/compliancepages/PAPGprivacypolicy';
// import PapgTermsOfService from './pages/compliancepages/PapgTermsofService';
// import QrCodeComponent from './pages/QrCodeComponent';
// import NewsTicker from './components/NewsTicker';
// import PhishingAwareness from './infra/PhishingAwareness';
// import PhishingReport from './infra/PhishingReport';

// const Home = () => (
//   <>
//   {/* <NewsTicker /> */}
//     <AutoCarousel />
//     <TrustedPartners />
//     <SmartSolutions />
//     <TransactionStats />
//     <UnlockRevenue />
//     {/* <SecurePayments /> */}
//     <Milestones />
//     <AwardsSection />
//         {/* <DownloadPage/> */}
//   </>
// );

// const App = () => {
//   return (
//     <Routes>
//       {/* Public Routes with Navbar & Footer */}
//       <Route element={<PublicLayout />}>
//         <Route path="/" element={<Home />} />
//         <Route path="/compliance-center" element={<ComplianceCenter />} />
//         <Route path="/download" element={<Downloadpage />} />
//         <Route path="/boardmembers" element={<BoardMembers />} />
//         <Route path="/tapay" element={<TAPAYSection />} />
//         <Route path="/testing-certification" element={<TestingService />} />
//         <Route path="/security-awareness" element={<CyberSecuritySection />} />
//         <Route path="/senior-management" element={<SeniorManagement />} />
//         <Route path="/tapayx" element={<TaPayxPage />} />
//         <Route path="/ta-api-banking-platform" element={<TAApiBankingPlatform />} />
//         <Route path="/citizen-wallet" element={<CitizenWallet />} />
//         <Route path="/career" element={<CareerSection />} />
//         <Route path="/contactus" element={<ContactSection />} />
//         <Route path="/aboutus" element={<AboutPage />} />
//         <Route path="/bbps-services" element={<BBPSService />} />
//         <Route path="/upipayments" element={<UpiPayments />} />
//         <Route path="/reconciliation-settlement" element={<SettlementSection />} />
//         <Route path="/job-application" element={<JobApplicationForm />} />
//         <Route path="/aadhaar-auth-solutions" element={<AadhaarHeroSection />} />
//            <Route path="/onboarding-stack" element={<OnboardingStack />} />

//         {/* Compliance pages */}
//         <Route path="/compliance-center/tag-wallet-terms-conditions" element={<TAGTermsandConditions />} />
//         <Route path="/compliance-center/customer-grievance-policy" element={<CustomerGrievancePolicy />} />
//         <Route path="/compliance-center/customer-protection-policy" element={<CustomerProtectionPolicy />} />
//         <Route path="/compliance-center/customer-security-awareness-information" element={<CustomerSecurityAwareness />} />
//         <Route path="/compliance-center/data-privacy-policy" element={<DataPrivacyPolicy />} />
//         <Route path="/compliance-center/dispute-redressal-mechanism" element={<DisputeRedressalMechanism />} />
//         <Route path="/compliance-center/ppi-rules" element={<PPIRules />} />
//         <Route path="/compliance-center/roles-responsibilities-of-npci-psb-tpap" element={<RolesResponsibilities />} />
//         <Route path="/compliance-center/ta-wallet-terms-conditions" element={<TAWalletTermsConditions />} />
//         <Route path="/compliance-center/terms-of-reference-of-csr-program-tripartite-agreement" element={<CSRProgramTripartiteAgreement />} />
//         <Route path="/compliance-center/terms-conditions-kannada" element={<TermsConditionsKannada />} />
//         <Route path="/compliance-center/terms-conditions-hindi" element={<TermsConditionHindi />} />
//         <Route path="/compliance-center/fraud-awareness" element={<FraudAwareness />} />
//          <Route path="/compliance-center/papgprivacy-policy" element={<PrivacyPolicy />} />
//             <Route path="/compliance-center/papg-termsof-service" element={<PapgTermsOfService />} />
//         <Route path="/downloadqr" element={<QrDownload />} />
//             <Route path="/generaterq" element={<QrGenerator/>} />
//                   <Route path="/singleqr" element={<SingleQr/>} />
//                   <Route path="/app" element={<AppLanding />} />
//                    <Route path="/qr" element={<QrCodeComponent />} />
                  
//       </Route>

//       {/* Dashboard/Admin Routes without Navbar & Footer */}
//        <Route path="login" element={<LoginPage/>} />
//         <Route path="/taadmin" element={<DashboardLayout />}>
   
//   <Route index element={<Dashboard />} />
    
//   <Route path="new-job-form" element={<NewJobForm />} />

// </Route>
// <Route
//  path="/phishing-awareness"
//  element={<PhishingAwareness />}
// />
// <Route
//  path="/phishing-report"
//  element={<PhishingReport />}
// />
//     </Routes>
    
//   );
// };

// export default App;
